
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { ChatList } from "@/components/chat/chat-list"
import { ChatConversation } from "@/components/chat/chat-conversation"
import { useChatConversations } from "@/api/chat"
import { Input } from "@/components/ui/input"
import { Search } from "lucide-react"
import { PageHeader } from "@/components/shared/page-header"

export default function ChatPage() {
  const { t } = useTranslation()
  const [selectedConversation, setSelectedConversation] = useState<string | null>(null)
  const [search, setSearch] = useState("")
  const { data, isLoading } = useChatConversations(search || undefined)

  const conversations = data?.conversations ?? []
  const selected = conversations.find((c) => c._id === selectedConversation)

  return (
    <div className="flex h-[calc(100vh-7rem)] flex-col gap-6">
      <PageHeader title={t("chat.title")} />

      <div className="grid min-h-0 flex-1 grid-cols-1 gap-6 md:grid-cols-3">
        <Card className="flex min-h-0 flex-col md:col-span-1">
          <CardHeader className="pb-3">
            <CardTitle>{t("chat.conversations")}</CardTitle>
            <div className="relative mt-2">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="pl-9"
              />
            </div>
          </CardHeader>
          <CardContent className="min-h-0 flex-1 overflow-hidden">
            <ChatList
              conversations={conversations}
              selectedConversation={selectedConversation}
              onSelectConversation={setSelectedConversation}
              isLoading={isLoading}
            />
          </CardContent>
        </Card>

        <Card className="flex min-h-0 flex-col md:col-span-2">
          <CardHeader className="pb-3">
            <CardTitle>
              {selected?.userName || t("chat.noConversationSelected")}
            </CardTitle>
          </CardHeader>
          <CardContent className="min-h-0 flex-1 overflow-hidden">
            {selectedConversation ? (
              <ChatConversation conversationId={selectedConversation} />
            ) : (
              <div className="flex items-center justify-center h-full text-muted-foreground">
                {t("chat.selectConversation")}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
